import type { ShapeTextChunk } from '@/lib/shapes/shape-text'

/**
 * How tall the overflow peek is: the bottom of the last laid-out row, but never less than the frame
 * itself, so the peek always covers the frame and then reaches down past its edge to where the
 * hidden text ends.
 */
export function peekContentHeight(
  chunks: ReadonlyArray<Pick<ShapeTextChunk, 'yTop' | 'rowHeight'>>,
  frameHeight: number
): number {
  const bottom = chunks.reduce((lowest, chunk) => Math.max(lowest, chunk.yTop + chunk.rowHeight), 0)

  return Math.max(frameHeight, Math.ceil(bottom))
}
